import { render } from "./SimpleLayout.vue?vue&type=template&id=f4ffdeb4&scoped=true"
const script = {}

import "./SimpleLayout.vue?vue&type=style&index=0&id=f4ffdeb4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ffdeb4"]])

export default __exports__